<div>
  <div mat-dialog-title *ngIf="data.title">
    <su-headline h="h3" skin="primary">{{ data.title }}</su-headline>
  </div>

  <div mat-dialog-content>
    <app-data-table
      [columns]="columns"
      [config]="config"
      [data]="data.docTypes"
      [selection]="selectedRowsChange$"
      (rowSelectedChange)="onRowSelectedChange($event)"></app-data-table>
  </div>

  <div mat-dialog-actions>
    <su-button
      skin="secondary"
      [label]="data.dismissButtonText! || 'Cancel'"
      mat-dialog-close></su-button>

    <su-button
      [disabled]="(selectedRows$ | async).length === 0"
      skin="primary"
      [label]="data.okButtonText! || 'Ok'"
      (onClick)="submit()"></su-button>
  </div>
</div>
